import {
    JAPAN_POSTAL_BANK, REGEX_FULL_WIDTH_NUMBERS, FULL_WIDTH_TO_HALF_WIDTH_DIFFERENCE,
    NUMERIC_FIELDS_ARRAY, METLIFE_CONTACT_PAGE_URL
} from './Constants'

export function isEmpty (value) {
    let isEmpty = false
    if (value === undefined || value === '') {
        isEmpty = true
    }
    return isEmpty
}

export function getFormattedDate (day, month, year) {
    // yyyy-MM-dd
    let formattedDate = ''
    if (!isEmpty(day) && !isEmpty(month) && !isEmpty(year)) {
        if (month.length === 1) {
            month = '0' + month
        }
        if (day.length === 1) {
            day = '0' + day
        }
        formattedDate = year + '-' + month + '-' + day
    }

    return formattedDate
}

export function replaceCommaWithSpace (value) {
    return value.replace(/，/g, '　').replace(/,/g, ' ')
}

export function isJapanPostalBank (bankName) {
    return bankName === JAPAN_POSTAL_BANK
}

export function getCurrentYear () {
    const now = new Date()
    const currentYear = now.getFullYear()
    return currentYear
}

export function removeCaptchaBadge () {
    const head = document.getElementsByTagName('head')[0]
    const script = document.getElementById('recaptcha-script')
    const recaptchaElements = document.getElementsByClassName('grecaptcha-badge')
    if (script !== null) {
        head.removeChild(script)
    }
    if (recaptchaElements.length) {
        const element = recaptchaElements[0]
        element.parentNode.removeChild(element)
    }
}

export function convertFullWidthNumbersToHalfWidth (value, fieldName) {
    if (NUMERIC_FIELDS_ARRAY.includes(fieldName)) {
        const regex = REGEX_FULL_WIDTH_NUMBERS
        value = value.replace(regex, function (ch) {
            return String.fromCharCode(ch.charCodeAt(0) - FULL_WIDTH_TO_HALF_WIDTH_DIFFERENCE)
        })
    }
    return value
}

export function handleCancel (message) {
    if (window.confirm(message)) {
        window.location.href = METLIFE_CONTACT_PAGE_URL
    }
}
